module.exports = __webpack_public_path__ + "80da1f9e1bd7d2ab0db8007a3d784693.svg";